<template>
  <div>
    <center>
      <v-img height="100%" :src="require('@/assets/Icon/HRM.jpg')"></v-img>
      <v-container fluid>
        <v-overlay :value="dataReady">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row dense v-if="!dataReady">
          <v-col>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="require('@/assets/Icon/Back.jpg')"
                max-height="30"
                max-width="100"
                :src="require('@/assets/Icon/Back.jpg')"
              ></v-img>

              <v-col cols="12">
                <v-sheet tile height="54" class="d-flex">
                  <v-select
                    v-model="month"
                    :items="monthNameTH"
                    dense
                    outlined
                    hide-details
                    label="เดือน"
                    class="ma-2"
                  ></v-select>
                  <v-select
                    v-model="year"
                    :items="yearsNumber"
                    dense
                    outlined
                    hide-details
                    label="ปี"
                    class="ma-2"
                  ></v-select>
                  <v-icon color="#871B12" size="30" @click="getData()"
                    >mdi-calendar-search</v-icon
                  >
                </v-sheet>
              </v-col>
            </v-card>

            <v-tabs-items v-model="tabs">
              <v-tab-item value="request">
                <v-card>
                  <v-tabs v-model="tabsHeaer" fixed-tabs>
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      id="request_waiting"
                      href="#request_waiting"
                      class="primary--text"
                      @click="getDataRequest('confirm')"
                    >
                      <v-icon>mdi-clock</v-icon>รออนุมัติ
                      <v-badge
                  v-if="dataCountItem > 0"
                  color="red"
                  :content="dataCountItem"
                >
                </v-badge>
                    </v-tab>
                    <v-tab
                      @click="getDataRequest('approve')"
                      id="approve_history"
                      href="#approve_history"
                      class="primary--text"
                    >
                      <v-icon>mdi-file-document</v-icon>ประวัติ
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tabsHeaer">
                    <v-tab-item value="request_waiting">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr style="background-color: #1b437c">
                              <th class="text-center">รายละเอียด</th>
                              <th class="text-center">สถานะ</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in dataItem" :key="item.welfareID">
                              <td>
                                ผู้ขอ : {{ item.empFull_NameTH }}<br />
                                ขอเบิก:
                                <strong>{{ item.welfareRequest }}</strong>
                                <br />
                                วันที่ : {{ item.welfare_date }} <br />
                              </td>
                              <td>
                                <v-btn
                                  class="ma-2"
                                  small
                                  dark
                                  color="success"
                                  elevation="2"
                                  @click="updateStatus(item, 'approve')"
                                >
                                  อนุมัติ
                                </v-btn>
                                <v-btn
                                  class="ma-2"
                                  small
                                  dark
                                  color="red"
                                  elevation="2"
                                  @click="updateStatus(item, 'unapprove')"
                                >
                                  ไม่อนุมัติ
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-tab-item>
                    <v-tab-item value="approve_history">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr style="background-color: #1b437c">
                              <th class="text-center">รายละเอียด</th>
                              <th class="text-center">สถานะ</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in dataItemDraft" :key="item.welfareID">
                              <td>
                                ผู้ขอ : {{ item.empFull_NameTH }}<br />
                                ขอเบิก:
                                <strong>{{ item.welfareRequest }}</strong>
                                <br />
                                วันที่ : {{ item.welfare_date }} <br />
                              </td>
                              <td>
                                <v-btn
                                  v-if="item.welfare_status == 'confirm'"
                                  color="amber"
                                  small
                                  dark
                                  elevation="2"
                                >
                                  รออนุมัติ
                                </v-btn>
                                <v-btn
                                  v-if="item.welfare_status == 'approve'"
                                  color="green"
                                  small
                                  dark
                                  elevation="2"
                                >
                                  อนุมัติ
                                </v-btn>
                                <v-btn
                                  v-if="item.welfare_status == 'unapprove'"
                                  dark
                                  color="red"
                                  small
                                  elevation="2"
                                >
                                  ไม่อนุมัติ
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
            <p></p>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="require('@/assets/Icon/Back.jpg')"
                max-height="30"
                max-width="100"
                :src="require('@/assets/Icon/Back.jpg')"
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
// moment().format('YYYY')
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
export default {
  // name: 'Adjust Check IN-OUT',
  data () {
    return {
      dataReady: false,
      shifttem: [],
      formUpdate: [],
      dataItem: [],
      dataItemDraft: [],
      dataCountItem: 0,
      year: '',
      month: '',
      day: '',
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      tabs: 'request',
      tabsHeaer: 'request_waiting',
      profile: [],
      form: {
        userLineuserId: '',
        userLinepictureUrl: ''
      },
      dialogForm: false,
      dialogApprove: false,
      currentMorDay: '',
      formRequest: [],
      nameRules: [(v) => !!v || 'Input is required'],
      valid_add: true
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    // this.currentMorDay = moment().add('days').format('YYYY-MM-DD')
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()
    await this.getData()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async getData () {
      await this.getDataRequest('confirm')
      this.getDataRequest('approve')
    },
    async getDataRequest (status) {
      var dataItem
      switch (status) {
        case 'confirm':
          this.dataItem = []
          this.dataCountItem = 0
          dataItem = await this.requestAPI('&welfare_status=confirm')
          if (dataItem.length > 0) {
            this.dataCountItem = dataItem.length
            this.tabs = 'request'
          }
          this.dataItem = dataItem.length > 0 ? dataItem : []
          break

        case 'approve':
          this.dataItemDraft = []
          dataItem = await this.requestAPI('&welfare_status=approve')
          if (dataItem.length > 0) {
            this.dataItemDraft = dataItem
          }
      }
    },
    async requestAPI (url) {
      const dataItem = await axios.get(
        this.DNS_IP +
          '/welfare/get?welfare_year=' +
          this.year +
          '&welfare_month=' +
          this.getMonthThToINT(this.month) +
          url,
        {
          headers: {
            'Application-Key': localStorage.getItem('ApplicationKey')
          }
        }
      )
      return dataItem.data ? dataItem.data : []
    },
    async updateStatus (dt, status) {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ' + status + 'ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#43A047',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.dataReady = false
          let ds = {
            welfareID: dt.welfareID,
            welfare_status: status,
            LAST_USER: this.profile.userName,
            LAST_USER_HR: this.profile.empCode
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/welfare/updateHR",
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
              await this.linenotify(ds, dt)
              await this.getData()
            })
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          this.getData()
          console.log(error)
        })
    },
    async linenotify (dt, item) {
      console.log('dt', dt)
      var massageNoti = 'ขอ' + item.welfareRequest +
            '\nชื่อพนักงาน : ' + item.empFull_NameTH +
            '\nแผนก : ' + item.masDepartmentName +
            '\nสาขา : ' + item.masBranchName +
            '\nบริษัท : ' + item.masCompanyName +
            '\nเบอร์โทรศัพท์ติดต่อ : ' + item.empTel
      let ds = {
        token: 'InNGxuG2UpomuqLnB9g3qTg6fUB6PKSZNkrci1BTfuA', // token
        message: massageNoti // text
      }
      let url = this.DNS_IP + '/line/hrm_notify'
      await axios.post(url, ds)
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/WelfareHistoryHR.vue